import { Donator } from './donator.interface';
import { ImportChannel } from '../services/import-channels/import-channel.model';
import { S3File } from './s3-file.interface';
import { Project } from './projects/project.interface';
import { Transaction } from '@ah-oh/fin-api';
import { DonatorDto } from '../dtos/donators/donator.dto';

export enum DonationType {
    MONEY = 'money',
    MATERIAL = 'material',
    ENDOWMENT = 'endowment',
    EXPENSE_WAIVER = 'expense-waiver',
}

export enum DonationPaymentStatus {
    PENDING = 'pending',
    PAID = 'paid',
}

export interface Donation {
    /**
     * The unique identifier of the donation
     */
    _id: string;
    /**
     * The donation id number of the donation
     */
    donationId: string;
    /**
     * The donation channel of the donation
     */
    channel?: ImportChannel | string;
    /**
     * The amount of the donation
     */
    amount: number;
    /**
     * The date of the donation
     */
    date: Date;
    /**
     * The type of the donation
     */
    type: DonationType;
    /**
     * The node of the donation
     */
    node: string;
    /**
     * Whether this donation is a permanent donation
     */
    permanentDonation: boolean;
    /**
     * The receipt timestamp of the donation
     */
    receipt?: Date;
    /**
     * Whether a receipt is needed
     */
    needReceipt: boolean;
    /**
     * The temporary donator of the donation (DonationChannel Altruja)
     */
    temporaryDonator?: DonatorDto;
    /**
     * The fin transaction of the donation (DonationChannel Finapi)
     */
    finTransaction?: Transaction;
    /**
     * Whether this donation is archived
     */
    archived: boolean;
    /**
     * The payment status of the donation
     */
    paymentStatus: DonationPaymentStatus;
    /**
     * Whether the donation was printed
     */
    printed: boolean;
    /**
     * The files of the donation
     */
    files: S3File[];
    /**
     * Whether this donation has an anonymous donator
     */
    hasAnonymousDonator?: boolean;

    /**
     * Whether this donation is purpose binding
     */
    purposeBinding: boolean;
    /** purposeBinding = true */
    /**
     * The purpose name of the donation (purposeBinding = true)
     */
    purposeName?: string;

    /**
     * The pdf job id of the donation
     */
    pdfJobId?: string;

    /** type MATERIAL */
    /**
     * Whether this donation is company material (for type MATERIAL)
     */
    companyMaterial?: boolean;
    /**
     * Whether this donation is private material (for type MATERIAL)
     */
    privateMaterial?: boolean;
    /**
     * Whether this donation is unknown material (for type MATERIAL)
     */
    unknownMaterial?: boolean;
    /**
     * Whether this donation is material files (for type MATERIAL)
     */
    materialFiles?: boolean;

    /** type EXPENSE_WAIVER  */
    /**
     * Whether this donation is asset stock (for type EXPENSE_WAIVER)
     */
    assetStock?: boolean;
    /**
     * Whether this donation is not consumable (for type EXPENSE_WAIVER)
     */
    notConsumable?: boolean;

    /**
     * The donator of the donation
     */
    donator?: Donator | string;
    /**
     * The company of the donation
     */
    company: string;

    /**
     * The project of the donation
     */
    project: Project | string;

    /**
     * The creation timestamp when this donation was created
     */
    createdAt: Date;
    /**
     * The timestamp when this donation was last updated
     */
    updatedAt: Date;
}
